import { Accordion, useAccordionButton } from 'react-bootstrap'
import { FormattedMessage } from 'react-intl'
import OutlinedButton from '../../ui/OutlinedButton/OutlinedButton'
import messages from './module/messages'

// Import styles
import classes from './FilterTable.module.scss'
import Filter3 from '../Filter/Filter3'
import { IFilterTableButton, IFilterTableProps } from './module/constants'
import { useEffect, useState } from 'react'
import { ISectionType } from '../../common/TablesConfiguration/tcConstants'
import {
  setFilterConfigurationState,
  setTableConfigurationState,
} from '../../common/TablesConfiguration/tcUtils'
import { createStructuredSelector } from 'reselect'
import { selectTablesConfiguration } from '../../common/TablesConfiguration/tcSelectors'
import { connect } from 'react-redux'

const FilterTableButton = (props: IFilterTableButton) => {
  const { eventKey, fullColored } = props
  const showHideFilter = useAccordionButton(eventKey)

  return (
    <OutlinedButton
      fullColored={fullColored}
      isFilterButton
      onClick={showHideFilter}
    >
      <FormattedMessage {...messages.filter} />
    </OutlinedButton>
  )
}

export const FilterTable3 = (props: IFilterTableProps) => {
  const {
    fullColored,
    isAccordion,
    sectionType,
    advancedFilter,
    tableType,
    typeFilter,
    simpleFilterFields = [] as string[],
    tablesConfiguration,
  } = props

  // TABLE CONFIGURATION (FILTER)
  const [blockAdvancedFilter, setBlockAdvancedFilter] = useState(
    !advancedFilter
  )
  const [hideColumns, setHideColumns] = useState({})
  const [columnOrder, setColumnOrder] = useState([] as string[])

  useEffect(() => {
    if (
      sectionType &&
      tableType &&
      sectionType !== ISectionType.HISTORY_REQUEST
    ) {
      let requestTableConfiguration = tablesConfiguration.filter(
        (table) => table.section === sectionType && table.type === tableType
      )
      if (requestTableConfiguration[0])
        setFilterConfigurationState(
          requestTableConfiguration[0],
          typeFilter,
          simpleFilterFields,
          setHideColumns,
          setColumnOrder,
          setBlockAdvancedFilter
        )
    } else if (
      sectionType &&
      tableType &&
      sectionType === ISectionType.HISTORY_REQUEST
    ) {
      let requestTableConfiguration = tablesConfiguration.filter(
        (table) => table.section === sectionType && table.type === tableType
      )
      setBlockAdvancedFilter(false)
      setTableConfigurationState(
        requestTableConfiguration[0],
        setColumnOrder,
        null,
        setHideColumns
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tablesConfiguration])

  if (isAccordion) {
    return (
      <div className={classes.filterTableContainer}>
        <Accordion defaultActiveKey="1">
          <div>
            <Accordion.Collapse eventKey="0">
              <div
                className={
                  fullColored ? classes['content-colored'] : classes.content
                }
              >
                <Filter3
                  allowAdvancedFilter={!blockAdvancedFilter}
                  columnOrder={columnOrder}
                  customHideColumns={hideColumns}
                  {...props}
                />
              </div>
            </Accordion.Collapse>
            <div
              className={
                fullColored
                  ? classes['filter-button-colored']
                  : classes['filter-button']
              }
            >
              <FilterTableButton fullColored={fullColored} eventKey="0" />
            </div>
          </div>
        </Accordion>
      </div>
    )
  } else {
    return (
      <div
        className={fullColored ? classes['content-colored'] : classes.content}
      >
        <Filter3
          allowAdvancedFilter={!blockAdvancedFilter}
          columnOrder={columnOrder}
          customHideColumns={hideColumns}
          {...props}
        />
      </div>
    )
  }
}

const mapStateToProps: any = () =>
  createStructuredSelector({
    tablesConfiguration: selectTablesConfiguration,
  })

const withConnect: any = connect(mapStateToProps, null)

export default withConnect(FilterTable3)
